import NameForm from "../components/forms/NameForm";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import Maaameti_logo from "../images/Maa- ja Ruumiamet_sinine.svg";
import { useState, useContext, useEffect } from "react";
import RefNrIdForm from "../components/forms/RefNrIdForm";
import CodeForm from "../components/forms/CodeForm";
import CoordinatesForm from "../components/forms/CoordinatesForm";
import SettlementForm from "../components/forms/SettlementForm";
import { AppContext } from "../context/AppContext";
import {useTranslation} from 'react-i18next';

const Header = () => {

    const [showForm, setShowForm] = useState("");
    const appState = useContext(AppContext);
    const {t, i18n} = useTranslation();

    const changeLanguageHandler = (language: string) => {
        localStorage.setItem("appLanguage", language);
        i18n.changeLanguage(language);
    }

    useEffect(() => {
        if (localStorage.getItem("numberOfResults") !== null) {
            appState.setNumberOfResults(localStorage.getItem("numberOfResults"));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (
        <header>
            <Navbar collapseOnSelect expand="lg" bg="light" variant="light" aria-label="header-navbar">
                <Container>
                    <Nav>
                        <Navbar.Brand href="/"><img className="logo" src={Maaameti_logo} alt="Maa-ameti logo"/><p className="App-header">{t('title')}</p></Navbar.Brand>
                    </Nav>
                    <Nav>
                        <Nav.Link onClick={() => changeLanguageHandler("et")}>est</Nav.Link>
                        <Nav.Link onClick={() => changeLanguageHandler("en")}>eng</Nav.Link>
                    </Nav>
                </Container>
            </Navbar>
            <Navbar collapseOnSelect expand="lg" bg="light" variant="light" aria-label="header-menu">
                <Container>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav>
                            <Nav.Link onClick={(e) => {showForm !== "name" ? setShowForm("name") : setShowForm("")}}>{t('searchByName')}</Nav.Link>
                            <Nav.Link onClick={(e) => {showForm !== "refnrid" ? setShowForm("refnrid") : setShowForm("")}}>{t('searchByGPAID')}</Nav.Link>
                            <Nav.Link onClick={(e) => {showForm !== "code" ? setShowForm("code") : setShowForm("")}}>{t('searchByCodeNo')}</Nav.Link>
                            <Nav.Link onClick={(e) => {showForm !== "coordinates" ? setShowForm("coordinates") : setShowForm("")}}>{t('searchByCoords')}</Nav.Link>
                            <Nav.Link onClick={(e) => {showForm !== "settlement" ? setShowForm("settlement") : setShowForm("")}}>{t('searchBySettlementUnits')}</Nav.Link>
                            <NavDropdown id="nav-dropdown-light" title={t('calculatorMenuTitle')} menuVariant="light">
                                <NavDropdown.Item href="/geolest">{t('geoLESTMenu')}</NavDropdown.Item>
                                <NavDropdown.Item href="/gauss">{t('globalMenu')}</NavDropdown.Item>
                                <NavDropdown.Item href="/helm">{t('helmMenu')}</NavDropdown.Item>
                                <NavDropdown.Item href="/geoid2017">{t('geoidMenu')}</NavDropdown.Item>
                                <NavDropdown.Item href="/ymudel">{t('ymudelMenu')}</NavDropdown.Item>
                                <NavDropdown.Item href="/crdmudel">{t('crdMudelMenu')}</NavDropdown.Item>
                                <NavDropdown.Item href="/valgacrdmudel">{t('valgaCrdMudelMenu')}</NavDropdown.Item>
                                <NavDropdown.Item href="/hmudel">{t('hmudelMenu')}</NavDropdown.Item>
                            </NavDropdown>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            {
                showForm !== "" &&
                    <Navbar collapseOnSelect expand="lg" bg="light" variant="light">
                        <Container>
                            { showForm === "name" &&
                                <NameForm />
                            }
                            { showForm === "refnrid" &&
                                <RefNrIdForm />
                            }
                            { showForm === "code" &&
                                <CodeForm />
                            }
                            { showForm === "coordinates" &&
                                <CoordinatesForm />
                            }
                            { showForm === "settlement" &&
                                <SettlementForm />
                            }
                            </Container>
                    </Navbar>
          }
        </header>
    );
}


export default Header;
